import { render, staticRenderFns } from "./UsersEditPage.vue?vue&type=template&id=5a2f04c9&"
import script from "./UsersEditPage.vue?vue&type=script&lang=js&"
export * from "./UsersEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports